export const RegionType = { None: "", LGA: "LGA", StateRegion: "SR", REZ: "REZ" };

